import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSaleSummary, getPurchaseSummary, getAggregateSale, getCommercialSale, getMortarSale } from '@/service/operate/comprehensiveDaily';
export default function useSaleSummary(params) {
  var saleSummary = ref({
    aggregateTotalMoney: 0,
    aggregateTotalMoneyYuan: 0,
    aggregateTotalSettleValue: 0,
    commercialTotalMoney: 0,
    commercialTotalMoneyYuan: 0,
    commercialTotalSettleValue: 0,
    mortarTotalMoney: 0,
    mortarTotalMoneyYuan: 0,
    mortarTotalSettleValue: 0 // 砂浆进料量（吨）
  });
  var purchaseSummary = ref({
    mortarTotalSingular: 0,
    mortarTotalAveragePrice: 0,
    aggregateTotalSingular: 0,
    aggregateTotalSettleValue: 0,
    aggregateTotalAveragePrice: 0,
    commercialTotalSingular: 0,
    aggregateTotalMoney: 0,
    commercialTotalMoney: 0,
    commercialTotalAveragePrice: 0,
    commercialTotalSettleValue: 0,
    mortarTotalMoney: 0,
    mortarTotalSettleValue: 0,
    aggregateTotalMoneyYuan: 0,
    commercialTotalMoneyYuan: 0,
    mortarTotalMoneyYuan: 0 // 砂浆总金额（元）
  });
  var saleSummary1 = ref({
    aggregateTotalAveragePrice: 0,
    aggregateTotalSingular: 0,
    commercialTotalAveragePrice: 0,
    commercialTotalSingular: 0,
    mortarTotalAveragePrice: 0,
    mortarTotalSingular: 0 // 砂浆单数
  });
  // 查询时间范围内停机详情
  var getSaleSummaryAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSaleSummary(params.value);
          case 2:
            data = _context.sent;
            saleSummary.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSaleSummaryAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  // 查询采购详情数据
  var getPurchaseSummaryAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getPurchaseSummary(params.value);
          case 2:
            data = _context2.sent;
            purchaseSummary.value = data;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getPurchaseSummaryAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  // 销量数据-骨料
  var getAggregateSaleAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAggregateSale(_.assign({}, params.value, {
              type: '5'
            }));
          case 2:
            data = _context3.sent;
            saleSummary1.value.aggregateTotalAveragePrice = data.totalAveragePrice;
            saleSummary1.value.aggregateTotalSingular = data.totalSingular;
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getAggregateSaleAsync() {
      return _ref3.apply(this, arguments);
    };
  }();
  // 销量数据-商砼
  var getCommercialSaleAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getCommercialSale(_.assign({}, params.value, {
              type: '0'
            }));
          case 2:
            data = _context4.sent;
            saleSummary1.value.commercialTotalAveragePrice = data.totalAveragePrice;
            saleSummary1.value.commercialTotalSingular = data.totalSingular;
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getCommercialSaleAsync() {
      return _ref4.apply(this, arguments);
    };
  }();
  // 销量数据-砂浆
  var getMortarSaleAsync = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getMortarSale(_.assign({}, params.value, {
              type: '0'
            }));
          case 2:
            data = _context5.sent;
            saleSummary1.value.mortarTotalAveragePrice = data.totalAveragePrice;
            saleSummary1.value.mortarTotalSingular = data.totalSingular;
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getMortarSaleAsync() {
      return _ref5.apply(this, arguments);
    };
  }();
  var getSaleSummaryAsync1 = function getSaleSummaryAsync1() {
    getAggregateSaleAsync();
    getCommercialSaleAsync();
    getMortarSaleAsync();
  };
  //销量数据
  var saleData = computed(function () {
    return [{
      money: saleSummary.value.aggregateTotalMoney,
      amount: saleSummary.value.aggregateTotalSettleValue,
      totalSingular: saleSummary1.value.aggregateTotalSingular,
      totalAveragePrice: saleSummary1.value.aggregateTotalAveragePrice,
      desc: '骨料',
      routeName: 'SalesAggregateDailyReport'
    }, {
      money: saleSummary.value.mortarTotalMoney,
      amount: saleSummary.value.mortarTotalSettleValue,
      totalSingular: saleSummary1.value.mortarTotalSingular,
      totalAveragePrice: saleSummary1.value.mortarTotalAveragePrice,
      desc: '砂浆',
      routeName: 'SaleMortarDailyReport'
    }, {
      money: saleSummary.value.commercialTotalMoney,
      amount: saleSummary.value.commercialTotalSettleValue,
      totalSingular: saleSummary1.value.commercialTotalSingular,
      totalAveragePrice: saleSummary1.value.commercialTotalAveragePrice,
      desc: '商砼',
      routeName: 'SaleShangTongDailyReport'
    }];
  });
  //采购数据
  var purchaseData = computed(function () {
    return [{
      title: '骨料',
      routeName: 'PurchaseAggregateDailyReport',
      children: [{
        desc: '总进料量/吨',
        value: purchaseSummary.value.aggregateTotalSettleValue
      }, {
        desc: '总单数/单',
        value: purchaseSummary.value.aggregateTotalSingular
      }, {
        desc: '金额/元',
        value: purchaseSummary.value.aggregateTotalMoneyYuan
      }
      // {
      //   desc: '均价/元',
      //   value: purchaseSummary.value.aggregateTotalAveragePrice
      // }
      ]
    }, {
      title: '砂浆',
      routeName: 'PurchaseMortarDailyReport',
      children: [{
        desc: '总进料量/吨',
        value: purchaseSummary.value.mortarTotalSettleValue
      }, {
        desc: '总车次/次',
        value: purchaseSummary.value.mortarTotalSingular
      }, {
        desc: '金额/元',
        value: purchaseSummary.value.mortarTotalMoneyYuan
      }
      // {
      //   desc: '均价/元',
      //   value: purchaseSummary.value.mortarTotalAveragePrice
      // }
      ]
    }, {
      title: '商砼',
      routeName: 'purchaseShangTongDailyReport',
      children: [{
        desc: '总进料量/吨',
        value: purchaseSummary.value.commercialTotalSettleValue
      }, {
        desc: '总车次/次',
        value: purchaseSummary.value.commercialTotalSingular
      }, {
        desc: '金额/元',
        value: purchaseSummary.value.commercialTotalMoneyYuan
      }
      // {
      //   desc: '均价/元',
      //   value: purchaseSummary.value.commercialTotalAveragePrice
      // }
      ]
    }];
    // return [
    //   {
    //     money: purchaseSummary.value.aggregateTotalMoney,
    //     amount: purchaseSummary.value.aggregateTotalSettleValue,
    //     desc: '骨料',
    //     routeName: 'PurchaseAggregateDailyReport'
    //   },
    //   {
    //     money: purchaseSummary.value.commercialTotalMoney,
    //     amount: purchaseSummary.value.commercialTotalSettleValue,
    //     desc: '商砼',
    //     routeName: 'purchaseShangTongDailyReport'
    //   },
    //   {
    //     money: purchaseSummary.value.mortarTotalMoney,
    //     amount: purchaseSummary.value.mortarTotalSettleValue,
    //     desc: '砂浆',
    //     routeName: 'PurchaseMortarDailyReport'
    //   }
    // ]
  });
  return [saleSummary, saleData, purchaseData, getSaleSummaryAsync, getSaleSummaryAsync1, getPurchaseSummaryAsync];
}